<template>
  <button
    type="button"
    class="btn"
    v-on="$listeners"
  >
    <IconChevronUp class="chevron" v-if="active"/>
    <IconChevronDown class="chevron" v-else/>
    <slot/>
  </button>
</template>

<script>
import IconChevronDown from '@primer/octicons/build/svg/chevron-down-16.svg'
import IconChevronUp from '@primer/octicons/build/svg/chevron-up-16.svg'

export default {
  name: 'TableToggleButton',
  components: {
    IconChevronDown,
    IconChevronUp,
  },
  props: {
    active: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.btn-outline-secondary {
  fill: $secondary;
  &:hover {
    fill: white;
  }
}
.chevron {
  transition: fill 0.2s;
}
</style>
